import $utils from '@/utils/util.js'
import {
	toPay
} from '@/api/nsh.js'
import dsbridge from 'dsbridge'
export const nshScheme = process.env.NODE_ENV === 'development' ? 'http://192.168.1.188:5175#/trade?args=' :
	'csii://www.4001961200.com?args='
export const nshPayTitle = '深圳农商银行收银台'
export const oldOrderUrl = (process.env.NODE_ENV === 'development' ? 'http' : 'https') +
	'://nsh.kingmaimai.com/pages/user/authCheck';
export const isInNsh = () => {
	return /(localhost)|(srcb)|(app)|(alpha)/.test(window.location.hostname.toLowerCase())
}
export const nshPay = (order_id, isFromCreate = false) => {
	if (!isInNsh()) {
		return false
	}
	toCashDesk(order_id, isFromCreate)
	return true;
}
export const toCashDesk = (order_id, isFromCreate) => {
	uni.showLoading({
		title: '支付请求中....',
		mask: true
	})
	toPay(order_id).then(({
		data
	}) => {
		if (data.status && data.status == 'success') {
			let goPages = '/pages/order_pay_status/index?order_id=' + order_id + '&msg=支付成功&status=1';
			$utils.Tips({
				title: '支付成功',
				icon: 'success'
			}, {
				tab: 5,
				url: goPages
			});
		} else {
			setTimeout(function() {
				uni.showModal({
					title: '温馨提示',
					content: '您的订单暂未支付成功,是否继续支付？',
					confirmColor: '#fcc800',
					confirmText: '前往支付',
					cancelText: '查看订单',
					success: function(res) {
						if (res.confirm) {
							toCashDesk(order_id, true);
						} else {
							uni.redirectTo({
								url: `/pages/order_details/stay?order_id=${order_id}`
							})
						}
					}
				})
			}, 1000)
			window.location.href = nshScheme + data.payUrl
		}
	}).catch(err => {
		//创建页面
		let modalObj;
		if (isFromCreate) {
			modalObj = {
				title: '错误提示',
				content: err,
				confirmColor: '#fcc800',
				confirmText: '返回上页',
				cancelText: '查看订单',
				success: function(res) {
					if (res.confirm) {
						uni.redirectTo({
							url: `/pages/order_details/stay?order_id=${order_id}`
						})
					} else {
						uni.navigateBack({})
					}
				}
			}
		} else {
			modalObj = {
				title: '错误提示',
				content: err,
				confirmColor: '#fcc800',
				confirmText: '知道了',
				showCancel: false,
				success: function(res) {

				}
			}
		}
		uni.showModal(modalObj)
	}).finally(() => {
		uni.hideLoading()
	})
}
//网站维护或暂停支付弹框提醒
export const stopServiceCheck = (config, type = 1) => {
	let _switch = config.stop_service_switch
	let _timeRange = config.stop_service_timerange;
	let _message = config.stop_service_message
	let _type = config.stop_service_type;
	if (_switch == 1) {
		let timeRange = (_timeRange || '').split(/[,|]/);
		if (timeRange.length != 2) {
			return false;
		}
		let nowStamptime = new Date().getTime();
		if (Date.parse(timeRange[0]) < nowStamptime && nowStamptime < Date.parse(timeRange[1])) {
			let tips = _message || '网站将于' + timeRange[0] + '至' + timeRange[1] +
				'进行维护，暂停' + (type == 1 ? '访问' : '结算')
			if (type == 1 && _type == 1) {
				if (isInNsh()) {
					uni.showModal({
						title: '维护提醒',
						content: tips,
						showCancel: false,
						confirmText: '知道了',
						confirmColor: '#fcc800',
						complete: () => {
							dsbridge.call('closeCurrentPage')
						}
					})
				} else {
					const mask = document.createElement('div')
					mask.id = 'ddk-mask'
					const tipText = document.createElement('div');
					tipText.style = 'width:78%;height:25%;background:white;border-radius:5px;padding:10px;'
					tipText.innerHTML =
						'<div style="text-align:center;height:45px;line-height:45px;"><b>温馨提示</b></div><text style="text-align:center;font-size:15px;color:#999;display:flex;align-items:center;height:60%;">' +
						tips + '</text>';
					mask.appendChild(tipText)
					document.body.appendChild(mask)
				}
				return true;
			}
			if(type !=1 && _type==2){
				uni.showModal({
					title: '维护提醒',
					content: tips,
					showCancel: false,
					confirmText: '知道了',
					confirmColor: '#fcc800',
					complete: () => {
						
					}
				})
			}
			return true;
		}
	}
	return false;
}